<template>
  <div class="extract-status">
    <h2>Extract Status</h2>
    <reporting-api pageName="ExtractStatus">
      <template v-slot="data">
        <p>Current status for this month's scan (extract status is reset after each monthly scan).</p>
        <b-table :items="data.page.Extracts" :fields="['extract', 'status']"/>
      </template>
    </reporting-api>
  </div>
</template>

<script>
import ReportingApi from '@/components/ReportingApi.vue'

export default {
  components: { ReportingApi }
}
</script>
